import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TauriImage from "../../../TauriImage/TauriImage";
import "./TauriDatePickerPlanning.css";

const TauriDatePickerPlanning = ({ onDateChange, cyclePeriod, currentValue, maxValue }) => {
    // Ensure the default date is set correctly with UTC+8 consideration
    const getTodayWithTimezoneOffset = () => {
        const now = new Date();
        now.setHours(0, 0, 0, 0); // Ensuring time does not affect date selection
        return now;
    };

    const [selectedDate, setSelectedDate] = useState(getTodayWithTimezoneOffset());

    const getFormattedDate = (date) => {
        return date.toLocaleDateString("en-CA"); // Formats correctly as YYYY-MM-DD
    };

    const getRange = (date) => {
        const year = date.getFullYear();
        const month = date.toLocaleDateString("en-US", { month: "long" });
        const isFirstHalf = date.getDate() <= 15;
        const startDay = isFirstHalf ? 1 : 16;
        const endDay = isFirstHalf ? 15 : new Date(year, date.getMonth() + 1, 0).getDate();
        return `${month} ${startDay} to ${endDay}, ${year}`;
    };

    const handleDateChange = (date) => {
        if (!date) return;

        date.setHours(0, 0, 0, 0); // Ensure correct day is maintained
        setSelectedDate(date);
        if (onDateChange) onDateChange(getFormattedDate(date));
    };

    const handlePrev = () => {
        setSelectedDate((prev) => {
            const newDate = new Date(prev);
            const isFirstHalf = newDate.getDate() <= 15;

            if (isFirstHalf) {
                // Move to previous month's second half
                newDate.setMonth(newDate.getMonth() - 1);
                newDate.setDate(16);
            } else {
                // Move to first half of the same month
                newDate.setDate(1);
            }

            newDate.setHours(0, 0, 0, 0); // Prevent timezone shifts
            if (onDateChange) onDateChange(getFormattedDate(newDate));
            return newDate;
        });
    };

    const handleNext = () => {
        setSelectedDate((prev) => {
            const newDate = new Date(prev);
            const isFirstHalf = newDate.getDate() <= 15;

            if (isFirstHalf) {
                // Move to second half of the same month
                newDate.setDate(16);
            } else {
                // Move to next month's first half
                newDate.setMonth(newDate.getMonth() + 1);
                newDate.setDate(1);
            }

            newDate.setHours(0, 0, 0, 0); // Prevent timezone shifts
            if (onDateChange) onDateChange(getFormattedDate(newDate));
            return newDate;
        });
    };


    const getProgressPrecentage = (value, max) => {
        return (value / max) * 100
    }

    return (
        <div className="tauri-datepicker-planning px-1">
            <div className="progress-bar" style={{ width: `${getProgressPrecentage(currentValue, maxValue)}%` }}></div>
            <div className="tauri-datepicker-planning-range d-flex align-items-center justify-content-between w-100">
                <TauriImage localImage="/Images/arrow-left.svg" alt="arrow-left" onClick={handlePrev} className="dt-arrowleft" />
                <div className="d-flex align-items-center justify-content-between w-100">
                    <DatePicker
                        selected={selectedDate}
                        onChange={handleDateChange}
                        dateFormat="EEEE, MMMM d"
                        popperPlacement="bottom-end"
                        customInput={
                            <div className="datepicker-input d-flex align-items-center">
                                <div className="date-display">{cyclePeriod} - {getRange(selectedDate)}</div>
                                <TauriImage localImage="/Images/arrow-down.svg" alt="arrow-down" className="dt-arrowdown" color={"#000"} />
                            </div>
                        }
                    />
                    <div className="d-flex align-items-center">
                        <TauriImage localImage="/Images/solar--user-bold.svg" alt="arrow-down" className="dt-arrowdown" color={"#128BE1"} />
                        <div className="display-value">{currentValue}/{maxValue}</div>
                    </div>
                </div>
                <TauriImage localImage="/Images/arrow-right.svg" alt="arrow-right" onClick={handleNext} className="dt-arrowright" />
            </div>

        </div>
    );
};

export default TauriDatePickerPlanning;
